<template>
    <div class="basic messages">
        <div class="head">{{$t('noticeInfo.tip')}}</div>
        <div class="section">
            <div style="width: 60%;">{{$t('noticeInfo.sectionTitle')}}</div>
            <div class="right">
                <div class="sectionItem timeWidth">{{$t('noticeInfo.time')}}</div>
                <div class="sectionItem">{{$t('noticeInfo.status')}}</div>
                <div class="sectionItem">{{$t('noticeInfo.operation')}}</div>
            </div>
        </div>
        <template v-if="messageReqSuccessFlag">
            <ul>
                <li v-for="(item,index) in messageDataList" :key="index">
                    <div class="item cursorPoint" @click="showDetail(item.id,index)">
                        <div class="headView">
                            <div class="title">
                                <i v-if="item.readFlag == 0"></i>
                                <span class="titleUnread" v-if="item.readFlag == 0">{{item.subject}}</span>
                                <span class="titleReaded" v-else>{{item.subject}}</span>
                            </div>
                            <div class="right">
                                <div class="sectionItem timeWidth">
                                    <div style="color:#999;">{{item.publishedAt|timeSwitchAll}}</div>
                                </div>

                                <div class="sectionItem">
                                    <div
                                        class="status unread"
                                        v-if="item.readFlag == 0"
                                    >{{$t('noticeInfo.unread')}}</div>
                                    <div class="status readed" v-else>{{$t('noticeInfo.readed')}}</div>
                                </div>

                                <div class="sectionItem">
                                    <img loading="lazy"
                                        v-lazy="require('../../../static/image/ss/delete.png')"
                                        class="cursorPoint"
                                        @click.stop="deleteMessage(item.id)"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="content" v-if="selectIndex == index">{{item.content}}</div>
                    </div>
                </li>
            </ul>

            <!-- 底部 -->
            <div class="msgBottom">
                <div class="msgPagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-size="pageSize"
                        :hide-on-single-page="hidePagination"
                        layout="pager"
                        :total="totalRecords"
                        :pager-count="5"
                        @size-change="sizeChange"
                        @current-change="currentChange"
                    ></el-pagination>
                </div>
                <div class="rightBtn">
                    <div
                        class="allDelete allBtn u-flex-all cursorPoint buttonHover1"
                        @click="deleteAllMsgs"
                    >{{$t('noticeInfo.deleteAll')}}</div>
                    <div
                        class="allBtn u-flex-all"
                        :class="
              needMarkReaded ? 'allReaded cursorPoint buttonHover1' : 'allReaded allReadedDisable'
            "
                        @click="markAllRead"
                    >{{$t('noticeInfo.readedAll')}}</div>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- 没数据 -->
            <Nothing img="nInfoMsgIsEmpty" :title="$t('noticeInfo.msgEmpty')"></Nothing>
        </template>
    </div>
</template>
<script>
import Nothing from "../../../components/nothing/nothing";
export default {
    name: "messages",
    data() {
        return {
            currentPage: 1,
            pageSize: 6,
            totalRecords: 0,
            //只有一页时，隐藏分页器
            hidePagination: false,
            messageDataList: [],
            isShowList: true,
            messageDetail: {},
            messageReqSuccessFlag: true, //默认请求有数据
            isScrollTop: false,
            isClick: false, //是否点击了（跳转详情）
            selectIndex: -1
        };
    },
    filters: {
        timeSwitch(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + ".";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + ".";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var time = Y + M + D;
                return time;
            }
        },
        timeSwitchAll(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D =
                    (date.getDate() < 10
                        ? "0" + date.getDate()
                        : date.getDate()) + " ";
                var h =
                    (date.getHours() < 10
                        ? "0" + date.getHours()
                        : date.getHours()) + ":";
                var m =
                    (date.getMinutes() < 10
                        ? "0" + date.getMinutes()
                        : date.getMinutes()) + ":";
                var s =
                    date.getSeconds() < 10
                        ? "0" + date.getSeconds()
                        : date.getSeconds();
                var time = Y + M + D + h + m + s;
                return time;
            }
        }
    },
    props: {
        curPage: Number
    },
    mounted() {
        this.getMessages();
    },
    methods: {
        async getMessages(str) {
            var _this = this;
            var data = {
                currentPage: _this.currentPage,
                pageSize: _this.pageSize,
                receiverType: 0
            };
            var res = await _this.$http.post(_this.$api.message, data, true);
            if (res.code == 0) {
                //实现点击tab，显示列表首页
                if (str) {
                    this.isShowList = true;
                }

                if (res.data.content.length > 0) {
                    _this.messageReqSuccessFlag = true;
                    _this.messageDataList = res.data.content;
                    _this.totalRecords = res.data.totalRecords;
                } else {
                    _this.messageReqSuccessFlag = false;
                }
            } else {
                _this.messageReqSuccessFlag = false;
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        currentChange(val) {
            this.currentPage = val;
            this.getMessages();
        },
        async deleteAllMsgs() {
            var _this = this;
            var messageIds = this.messageDataList.map(function(item) {
                return item.id;
            });
            //请求数据
            var data = {
                messageIds: messageIds,
                type: 0
            };
            var res = await _this.$http.deleteArray(
                _this.$api.deleteMessages,
                data
            );
            if (res.code == 0) {
                //删除成功
                //刷新页面
                _this.$message.success(
                    this.$t("noticeInfo.msgAllDeleteSuccess")
                );
                _this.currentPage--;
                _this.getMessages();
                //更新tab上通知的数量
                _this.$store.commit("updateUnRead", "message");
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        markAllRead() {
            //全部标记已读
            //若全部已读，退出
            if (!this.needMarkReaded) {
                return;
            }
            var messageIds = this.messageDataList.map(function(item) {
                return item.id;
            });
            this.markReaded(messageIds);
        },
        sizeChange() {},
        async showDetail(id, index) {
            //显示详情
            if (this.selectIndex == index) {
                this.selectIndex = -1;
            } else {
                this.selectIndex = index;
            }
            //标记已读
            var item = this.messageDataList.filter(function(item) {
                return item.id == id;
            });
            if (!item[0].readFlag) {
                await this.markReaded(id);
            }

            //显示详情
            // await this.messageDetailInter(id);
        },
        async markReaded(id) {
            //标记已读
            var _this = this;
            var messageIds = typeof id == "number" ? [id] : id;
            var data = {
                messageIds: messageIds,
                type: 0
            };
            const res = await _this.$http.put(_this.$api.readMessages, data);
            if (res.code == 0) {
                //手动更新已读
                _this.messageDataList.map(function(item) {
                    messageIds.map(function(it) {
                        if (item.id == it) {
                            item.readFlag = 1;
                        }
                    });
                });

                if (typeof id == "object") {
                    _this.$message.success(
                        this.$t("noticeInfo.msgAllReadSuccess")
                    );
                }

                //已读后，更新myPage页面的已读标志
                _this.$store.commit("updateUnRead", "message");
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        async messageDetailInter(id) {
            //站内信详情
            var _this = this;
            _this.isShowList = false;
            var data = id;
            const res = await _this.$http.get(
                _this.$api.messageInfo,
                data,
                true
            );
            if (res.code == 0) {
                _this.messageDetail = res.data;

                _this.isClick = false;
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        async deleteMessage(id) {
            var _this = this;
            //请求数据
            var data = "0/" + id;
            var res = await _this.$http.delete(_this.$api.deleteMessage, data);
            if (res.code == 0) {
                //删除成功
                _this.$message.success(this.$t("noticeInfo.msgDeleteSuccess"));
                //刷新页面
                if (this.messageDataList.length > 1) {
                    _this.getMessages();
                } else {
                    _this.currentPage--;
                    _this.getMessages();
                }

                //回到列表页
                _this.backToList();

                //更新tab上通知的数量
                _this.$store.commit("updateUnRead", "message");
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
            }
        },
        backToList() {
            this.isShowList = true;
            //详情清空
            this.messageDetail = {};
        }
    },
    computed: {
        needMarkReaded() {
            //只要有一个未读，显示全部已读
            return this.messageDataList.some(function(item) {
                return item.readFlag == 0;
            });
        }
    },
    components: {
        Nothing
    },
    watch: {
        curPage(n) {
            if (n) {
                //每次打开，默认请求第一页数据
                this.currentPage = 1;
                this.getMessages();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.basic {
    min-height: 6.5rem;
    position: relative;
}
.head {
    margin: 20px;
    background-color: #fff4d7;
    color: #f85a3f;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
}
.section {
    margin: 20px;
    background-color: #f7f7f7;
    color: #666;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
}

.item {
    margin: 20px;
    display: flex;
    border-bottom: 1px solid #f5f5f5;
    flex-direction: column;
    padding-bottom: 20px;
}
.headView {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
        margin-right: 10px;
        width: 25px;
        height: 30px;
    }
}
.right {
    width: 40%;
    display: flex;
    justify-content: space-between;
}
.title {
    margin: 10px;
    margin-left: 0px;
    font-size: 15px;
    font-weight: 500;
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.3rem;
    position: relative;
}
.title i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.1rem;
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 0.03rem;
    background-color: #ff3a2b;
}
.title .titleUnread {
    color: #313131;
}
.title .titleReaded {
    color: #999;
}
.sectionItem {
    width: 33%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.timeWidth {
    width: 40%;
}
.status {
    height: 20px;
    width: 50px;
    border-radius: 10px;
    color: #fff;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
}
.unread {
    background-color: #ff3a2b;
}
.readed {
    background-color: #d9dde1;
}

.content {
    color: #999;
    margin: 10px;
    background-color: #f5f5f5;
    padding: 10px;
    word-break: break-all;
}

.msgBottom {
    position: absolute;
    bottom: -0.2rem;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.4rem;
    box-sizing: border-box;
}
.rightBtn {
    display: flex;
}

.allBtn {
    width: 1.4rem;
    padding: 0 0.2rem;
    box-sizing: border-box;
    height: 0.44rem;
    line-height: 0.44rem;
    font-size: 0.16rem;
    border-radius: 0.06rem;
    margin-right: 0.15rem;
}

.allDelete {
    color: #fff;
    background-color: #ff3a2b;
}

.allReaded {
    color: #ff3a2b;
    border: 1px solid #ff3a2b;
}
.allReadedDisable {
    opacity: 0.5;
}
</style>
<style>
.messages .el-pager li {
    min-width: 20px !important;
    color: #999 !important;
    background: transparent !important;
    opacity: 0.8;
}
.messages .el-pager li.active {
    color: #ff3a2b !important;
}
.messages .el-pager li:hover {
    color: #ff3a2b !important;
}
.messages .el-pagination button:hover {
    color: #ff3a2b !important;
}
.messages .el-pagination .btn-prev,
.messages .el-pagination .btn-next {
    background: transparent !important;
}
.messages .el-pagination button:disabled {
    color: #c0c4cc !important;
    background: transparent !important;
}
</style>